import {
  SELECT_LESSON_PLANNER_WORKBOOK,
  SELECT_LESSON_PLANNER_NAVBAR_CHANGE,
  SET_CURRENT_LESSON_PLAN_WEEK,
  SET_NUMBER_OF_WEEKS,
  SET_LESSON_PLAN_DAY
} from './types';
import { LessonPlannerState, LessonPlannerAction } from './types';
import { LESSON_PLANNER_MODE, LESSON_PLANNER_VIEW } from 'types';
const initialState = {
  workbook: 'default',
  classroomId: '',
  teachingOrder: 'default',
  classroom: {},
  currentWeek: 0,
  currentDay: 0,
  mode: LESSON_PLANNER_MODE.LESSON_PLANNER,
  view: LESSON_PLANNER_VIEW.WEEK,
  currentlessonPlanWeek: 0,
  numberOfWeeks: null
};

const lessonPlannerReducer = (
  state: LessonPlannerState = initialState,
  action: LessonPlannerAction
) => {
  switch (action.type) {
    case SELECT_LESSON_PLANNER_WORKBOOK:
      return {
        ...state,
        workbook: action.workbook
      };
    case SET_CURRENT_LESSON_PLAN_WEEK:
      return {
        ...state,
        currentlessonPlanWeek: action.data
      };
    case SET_NUMBER_OF_WEEKS:
      return {
        ...state,
        numberOfWeeks: action.data
      };
    case SET_LESSON_PLAN_DAY:
      return {
        ...state,
        currentDay: action.data
      };
    case SELECT_LESSON_PLANNER_NAVBAR_CHANGE:
      return {
        ...state,
        [action.attribute]: action.value
      };
    default:
      return state;
  }
};

export default lessonPlannerReducer;
